import React from 'react'
import PropTypes from 'prop-types'
import IntlMessages from 'util/IntlMessages'
import CardLayout from 'components/CardLayout'

const LoginContainer = ({ headerLabelId, children }) => (
    <CardLayout columns={6} styleName={'mr-auto ml-auto'}>
      <div className="card-body text-center">
        <div className="login-header">
          <h1>{headerLabelId ? (<IntlMessages id={headerLabelId}/>) : ''}</h1>
        </div>
        {children}
      </div>
    </CardLayout>
)

LoginContainer.propTypes = {
  children: PropTypes.node
}

export default LoginContainer



// WEBPACK FOOTER //
// ./Linkgua/containers/LoginContainer.js